import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { getFeatureFlagsConfig } from '../services/getFeatureFlagsConfig'

interface InitialState {
	YANDEX_PAY: {
		ACTIVE: boolean
		SPLIT_MAX_LIMIT?: string //число в строке
	}
	DOLYAME: {
		ACTIVE: boolean
		MIN_PRICE_LIMIT?: string //число в строке
	}
	CAPTCHA: {
		ACTIVE: boolean
	}
}

const initialState: InitialState = {
	YANDEX_PAY: {
		ACTIVE: false,
		SPLIT_MAX_LIMIT: '0'
	},
	DOLYAME: {
		ACTIVE: false,
		MIN_PRICE_LIMIT: '99999999'
	},
	CAPTCHA: {
		ACTIVE: true
	}
}

export const appSlice = createSlice({
	name: 'app',
	initialState,
	reducers: {
		setFeatureFlafs: (state, action: PayloadAction<InitialState>) => {
			state.CAPTCHA = action.payload?.CAPTCHA || { ACTIVE: false }
			state.DOLYAME = action.payload?.DOLYAME || { ACTIVE: false }
			state.YANDEX_PAY = action.payload?.YANDEX_PAY || { ACTIVE: false }
		}
	},
	extraReducers: builder => {
		builder.addCase(getFeatureFlagsConfig.fulfilled, (state, action) => {
			return action.payload
		})
	}
})

export const { actions: appActions } = appSlice
export const { reducer: appReducer } = appSlice
